module.exports = __webpack_public_path__ + "img/code.185ba58a.png";